import React from "react";
import {
  FieldWrapper,
  FilterMultiSelect,
  FilterSearchableSelect,
  formatGroupedValues,
} from "./jobsFilterUtils";
import AccountingWeekPicker from "../fields/AccountingWeekPicker";
import { formatWeekChipLabel, getStaffDisplayName } from "./accountingFilterUtils";

export function AccountingPayStubsFilterFields({
  focusedFieldId,
  onFocusClear,
  filterPayer,
  filterPayerId,
  setFilterPayer,
  setFilterPayerId,
  filterWeek,
  setFilterWeek,
  weekData,
  filterStaffIds = [],
  setFilterStaffIds,
  selectedStaffLookup = {},
  setSelectedStaffLookup,
  payerList = [],
  weekFilterStaff = [],
}) {
  const payerOptions = payerList.map((p) => ({
    value: String(p.payer_id),
    label: String(p.name),
  }));

  const staffOptions = weekFilterStaff.map((s) => ({
    value: String(s.id),
    label: getStaffDisplayName(s) || s.name || `#${s.id}`,
  }));

  return (
    <>
      <FieldWrapper
        fieldId="payer"
        label="Payer"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterSearchableSelect
          id="accounting-paystubs-payer"
          value={filterPayerId ? String(filterPayerId) : ""}
          selectedLabel={filterPayer || "All"}
          onChange={(val) => {
            if (!val) {
              setFilterPayer("");
              setFilterPayerId(null);
            } else {
              const match = payerList.find((p) => String(p.payer_id) === String(val));
              setFilterPayer(match?.name || `#${val}`);
              setFilterPayerId(Number(val));
            }
          }}
          options={payerOptions}
          placeholder="Search Payer..."
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="week"
        label="Week"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <AccountingWeekPicker
          selectedWeek={filterWeek}
          onWeekChange={setFilterWeek}
          weekData={weekData}
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="staff"
        label="Staff"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterMultiSelect
          id="accounting-paystubs-staff"
          options={staffOptions}
          value={filterStaffIds.map(String)}
          onChange={(vals) => {
            const numericVals = vals.map(Number);
            setFilterStaffIds(numericVals);
            setSelectedStaffLookup((prev) => {
              const next = { ...prev };
              Object.keys(next).forEach((k) => {
                if (!numericVals.includes(Number(k))) {
                  delete next[k];
                }
              });
              numericVals.forEach((id) => {
                if (!next[id]) {
                  const match = weekFilterStaff.find((s) => Number(s.id) === id);
                  if (match) {
                    next[id] = getStaffDisplayName(match) || String(id);
                  }
                }
              });
              return next;
            });
          }}
          placeholder="Select Staff..."
        />
      </FieldWrapper>
    </>
  );
}

export function buildAccountingPayStubsFilterChips({
  searchTerm,
  filterPayer,
  filterWeek,
  weekData,
  filterStaffIds = [],
  weekFilterStaff = [],
  selectedStaffLookup = {},
}) {
  const chips = [];

  if (searchTerm) {
    chips.push({
      id: "search",
      key: "search",
      fieldId: "search",
      label: `Search: ${searchTerm}`,
    });
  }

  if (filterPayer) {
    chips.push({
      id: "payer",
      key: "payer",
      fieldId: "payer",
      label: `Payer: ${filterPayer}`,
    });
  }

  if (filterWeek) {
    chips.push({
      id: "week",
      key: "week",
      fieldId: "week",
      label: formatWeekChipLabel(filterWeek, weekData?.end_date),
    });
  }

  if (filterStaffIds.length > 0) {
    const formatStaff = (id) => {
      if (selectedStaffLookup[id]) return selectedStaffLookup[id];
      const match = weekFilterStaff.find((s) => Number(s.id) === Number(id));
      return getStaffDisplayName(match) || `#${id}`;
    };
    chips.push({
      id: "staff",
      key: "staff",
      fieldId: "staff",
      label: `Staff: ${formatGroupedValues(filterStaffIds, formatStaff, 3)}`,
    });
  }

  return chips;
}
